import contentRequest from '~/src/api/requests/contentRequest';
import { captureQueryError, TResponse } from '~/src/api/helper';

export const REQUEST_CONNECTION_TOOLTIP = 'request_connect_tooltip';
export const REQUEST_ADD_TV2 = 'request_add_tv2';
interface IQuiz {
    alias: string,
    bg_color: string,
    button_text: string,
    created_at: string,
    experiment_id: string,
    id: number,
    image: string,
    is_active: number,
    link: string,
    page_id: number | null,
    parent_id: number | null,
    subtitle: string,
    text_color: string,
    title: string,
    title_ad: string,
    updated_at: string,
}

interface IMeta {
    totalCount: number,
    pageCount: number,
    currentPage: number,
    perPage: number,
}

interface IContent {
    _links: unknown,
    _meta: IMeta,
    items: IQuiz[]
}

export type TDataResponse = TResponse<Record<string, IContent>, any>;

export const getContentBlock = async(cityDomain: string, alias: string): Promise<TDataResponse> => {
    const url = `${cityDomain}/v1/content-block?filter[alias]=${alias}`;

    try {
        const response = await contentRequest.getWithCache(url);

        return {
            isSuccess: true,
            payload: response.data
        };
    } catch (error) {
        return captureQueryError(error);
    }
};
